import { cloneDeep, orderBy, get } from 'lodash';
import { formatByType } from 'helpers/formatNumbers';
import { getChannelDisplayValue } from 'helpers/strings';

exports.requestPDFEndpoint = (state, params) => `${state.config.apiUrl}/v1/pdf/${params.template}`;

exports.activeRequestCount = state => state.exports.activeRequestCount;

exports.getNextPendingAction = state => state.exports.pendingActions[0];

exports.getDynamicProfilesCount = state => Object.keys(get(state, 'entities.meta.dynamicProfiles', {})).length;

const tableSort = (data, sortArr) => {
    const keys = [];
    const directions = [];
    for (let i = 0; i < sortArr.length; i += 1) {
        keys.push(sortArr[i].id);
        directions.push(sortArr[i].desc ? 'desc' : 'asc');
    }

    return orderBy(data, keys, directions);
};

function iterateColumns({
    col, depth, maxDepth, prev
}) {
    if (depth > maxDepth) {
        return prev;
    }

    if (col.columns && col.columns.length > 0) {
        prev[depth].push(
            {
                text: col.Header,
                colSpan: col.columns.length
            },
            // Add in empty entries to account for columns with wide spans
            ...[...Array(col.columns.length - 1)].map(() => ({}))
        );
        const incDepth = depth + 1;
        col.columns.forEach((c) => {
            iterateColumns({ col: c, depth: incDepth, maxDepth, prev });
        });
    } else {
        prev[maxDepth - 1].push({
            text: col.Header,
            ...col
        });
    }

    return prev;
}

const prepareTableForExport = ({
    key,
    value,
    cleanedMap,
    headerDepth = 1,
    columnReducer = columns => columns.filter(col => col.accessor)
}) => {
    const table = cloneDeep(value);
    table.type = 'table';
    let newData = cloneDeep(table.data);

    if (headerDepth > 1) {
        table.headers = value.columns.reduce((prev, col) => iterateColumns({
            col,
            depth: 0,
            maxDepth: headerDepth,
            prev
        }), [...Array(headerDepth)].map(() => [])); // default the headers array of arrays to provided depth

        const maxWidth = table.headers[table.headers.length - 1].length;

        table.headers.forEach((h) => {
            if (maxWidth - h.length) {
                // Backfill header dead space if any. Assume fill left to right
                [...Array(maxWidth - h.length)].forEach(() => h.unshift({}));
            }
        });

        // Columns are assumed to be the last row of the headers AoA
        table.columns = table.headers[table.headers.length - 1];
    } else {
        table.columns = columnReducer(table.columns);
    }

    if (table.defaultSorted && table.defaultSorted.length) {
        newData = tableSort(newData, table.defaultSorted);
    }

    let hasFooter = false;
    const footerData = {};
    newData = newData.map((row) => {
        table.columns.forEach((col) => {
            const { Cell, Footer, accessor, type } = col;
            if (Footer) {
                hasFooter = true;
                footerData[accessor] = formatByType(Footer.props.value, Footer.props.type);
            }

            if (Cell) {
                try {
                    if (type === 'channel') {
                        row[accessor] = getChannelDisplayValue(row[accessor]);
                    } else {
                        row[accessor] = formatByType(row[accessor], type);
                    }
                } catch (err) {} // eslint-disable-line
            }
        });

        return row;
    });

    const tableLenLimit = table.exportRows || table.minRows;
    if (tableLenLimit && tableLenLimit < newData.length) {
        newData = newData.slice(0, tableLenLimit);
    }

    table.columns.forEach(c => delete c.Footer);
    cleanedMap.set(key, {
        ...table,
        data: newData,
        footer: hasFooter ? footerData : null
    });
};

exports.getConfigs = (state) => {
    const cleanedMap = new Map();

    for (const [key, value] of state.exports.configs.entries()) { // eslint-disable-line no-restricted-syntax
        if (value.type === 'table') {
            prepareTableForExport({ key, value, cleanedMap, headerDepth: value.headerDepth });
        } else {
            cleanedMap.set(key, value);
        }
    }

    return cleanedMap;
};



// WEBPACK FOOTER //
// ./src/services/exports/selectors.js